import Computer from 'mbs-ui-shared@models/Computer';
import { RestoreTypeFromStorageTab } from 'mbs-ui-shared@models/backup/storages-type';

export type RestoreCaseType = 'virtualOrPhysical' | 'virtualizationPlatforms' | 'instantRestore' | 'cloudRestore';
export type SelectTargetComputerStepType = { computer: Computer; restoreTo: RestoreTypeFromStorageTab; valid: boolean };
export const SelectTargetComputerDefaultValue: SelectTargetComputerStepType = {
  computer: null,
  restoreTo: RestoreTypeFromStorageTab.current,
  valid: false
};
